document.addEventListener("DOMContentLoaded", function() {
    var queryParams = new URLSearchParams(window.location.search);
    var myParamValue = queryParams.get('variant');

    var addToCartButton = document.getElementById('add-to-cart-button');
    var selectSizeButton = document.getElementById('select-size-button');
    var sizeSelector = document.getElementById('size-selector');
    var errorMessage = document.getElementById('error-message');
    var errorMessage1 = document.getElementById('error-message1');
    var buyitnow = document.querySelector('.shopify-payment-button');
    var buynowError = document.getElementById('buynow_error-message');
    var addtocartError = document.getElementById('addtocart_error-message');
    var sizevariant = document.getElementById('size___variant');
    var close = document.querySelector('.sticky-close');
    
    // Modal elements
    var modal = document.getElementById('sizevariant-modal');
    
    function hideModal() {
        sizevariant.style.display = "none";
        modal.style.display = "none";
    }
    
    if (myParamValue) {
        addToCartButton.style.display = "block";
        selectSizeButton.style.display = "none";
        errorMessage.style.display = "none";
        errorMessage1.style.display = "none";
        buynowError.style.display = "none";
        addtocartError.style.display = "none";
    } else {
        document.querySelectorAll(".select-size-button").forEach((btn) => {
            btn.addEventListener("click", (e) => {
                modal.style.display = "block"; // Show the modal
                sizevariant.style.display = "block"; // Ensure content is visible
            });
        });
    }

    sizeSelector.addEventListener("change", function() {
        var selectedSize = sizeSelector.value;
        if (selectedSize) {
            addToCartButton.style.display = "block";
            selectSizeButton.style.display = "none";
            errorMessage.style.display = "none";
            errorMessage1.style.display = "none";
            buyitnow.style.display = "block";
            buynowError.style.display = "none";
            addtocartError.style.display = "none";
        } else {
            addToCartButton.style.display = "none";
            selectSizeButton.style.display = "block";
            buyitnow.style.display = "block";
        }
    });

    close.addEventListener("click", hideModal);

    selectSizeButton.addEventListener("click", function() {
        errorMessage.style.display = "block";
        addtocartError.style.display = "block";
        errorMessage1.style.display = "block";
    });

  addToCartButton.addEventListener("click", function() {
    hideModal();
  });

    buyitnow.addEventListener("click", function() {
        errorMessage.style.display = "block";
        buynowError.style.display = "block";
    });
    
    // Close modal when clicking outside of the modal content
    window.onclick = function(event) {
        if (event.target == modal) {
            hideModal();
        }
    }
});
			

   // console.log(window,'')				
   //  document.addEventListener("DOMContentLoaded", function() {				
   //  var queryParams = new URLSearchParams(window.location.search);				
   //  var myParamValue = queryParams.get('variant');	
    
   //    console.log(myParamValue,"");
   //     if (window.location.pathname.includes("/products/")) {
   //  var addToCartButton = document.getElementById('add-to-cart-button');
   //  var selectSizeButton = document.getElementById('select-size-button');	
   //  var sizeSelector = document.getElementById('size-selector');   
   //  var errorMessage = document.getElementById('error-message');
   //   var buyitnow = document.getElementById('simpl-checkout-product-v2');
      
   //  if (myParamValue) {	
   //    addToCartButton.style.display = "block";
   //      selectSizeButton.style.display = "none"; 
   //    errorMessage.style.display = "none";
   //     buyitnow.style.display = "none";
   //  } else {
   //    addToCartButton.style.display = "none";
   //      selectSizeButton.style.display = "block"; 
   //    buyitnow.style.display = "none"; 
   //  }	

   //     sizeSelector.addEventListener("change", function() {
   //          var selectedSize = sizeSelector.value;
   //       console.log(selectedSize,'ssssss')

   //          if (selectedSize) {
   //              addToCartButton.style.display = "block";
   //              selectSizeButton.style.display = "none";
   //              errorMessage.style.display = "none";
   //               buyitnow.style.display = "block";
   //          } else {
   //              addToCartButton.style.display = "none";
   //              selectSizeButton.style.display = "block"; 
   //               buyitnow.style.display = "none";
   //          }
   //      });
      
   //     selectSizeButton.addEventListener("click", function() {
   //          errorMessage.style.display = "block";
   //      });
   //     }
    				
   //  });				
